export class User {
    public username: string;
    public role: string;
    public password: string;
}  